import axios, { AxiosRequestConfig } from 'axios';
import { DataResponse, PagedResponse } from '../types/api';
import { SpecialExperience } from '../types/SpecialExperience';

const URL = '/v2/special-experiences';

class SpecialExperiencesService {
  static getByFilter(config?: AxiosRequestConfig): Promise<PagedResponse<SpecialExperience>> {
    return axios.get(URL, config);
  }

  static getByFilterForAdmin(config?: AxiosRequestConfig): Promise<PagedResponse<SpecialExperience>> {
    return axios.get(`${URL}?includeDisabled=true`, config);
  }

  static patch(
    id: number,
    data: SpecialExperience,
    config?: AxiosRequestConfig
  ): Promise<DataResponse<SpecialExperience>> {
    return axios.patch(`${URL}/${id}`, data, config);
  }

  static update(
    id: number,
    data: SpecialExperience,
    config?: AxiosRequestConfig
  ): Promise<DataResponse<SpecialExperience>> {
    return axios.put(`${URL}/${id}`, data, config);
  }

  static create(
    data: SpecialExperience,
    config?: AxiosRequestConfig
  ): Promise<DataResponse<SpecialExperience>> {
    return axios.post(URL, data, config);
  }

  static delete(id: number, config?: AxiosRequestConfig) {
    return axios.delete(`${URL}/${id}`, config);
  }
}

export { SpecialExperiencesService };
